import { render, staticRenderFns } from "./NewCardSpecimen.vue?vue&type=template&id=e6fd0446&scoped=true"
import script from "./NewCardSpecimen.vue?vue&type=script&lang=js"
export * from "./NewCardSpecimen.vue?vue&type=script&lang=js"
import style0 from "./NewCardSpecimen.vue?vue&type=style&index=0&id=e6fd0446&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6fd0446",
  null
  
)

export default component.exports